import { phone, email, pdfCommissions, pdfTraining1, pdfTraining2, pdfTraining3 } from '@/config'

const contacts = {
  whatsapp1: '+256782863240'
}

const referralLink = "https://aal4.adj.st/?adjust_t=v9yo7k0_76x32g3&adjust_campaign=app-test&adjust_deeplink=jumia%3A%2F%2Fug%2F&adjust_redirect=https%3A%2F%2Fwww.jumia.ug%2F%3Futm_source%3Djforce%26utm_medium%3Dreferral"

const dashboardGetUpdatedItems = [
  {
    disabled: true,
    img: 'img/dashboard/comingSoon.svg',
    title: {
      key: 'dashboard.media.jforce_blog'
    },
    newPage: true
  }
]

const dashboardContactTheTeamItems = [
    {
        img: 'img/dashboard/whatsapp.svg',
        title: {
            text: 'WhatsApp to get help'
        },
        link: 'https://wa.me/256740920779',
        newPage: true
    },
    {
    img: 'img/dashboard/contact-form.svg',
    title: {
      text: 'Contact us through this claim form'
    },
    link: 'https://docs.google.com/forms/d/1oo_3kbwGXbBaN_2LjaeEY-elA3z7Z_aQbKMcMf55drc/edit',
    newPage: true
  },
  {
    img: 'img/dashboard/icon-telegram.svg',
    title: {
      text: 'Join us on Telegram',
    },
    link: 'https://t.me/joinchat/CW4L9nXnaAdmZmQ8',
    newPage: true
  },
  {
    img: 'img/dashboard/whatsapp.svg',
    title: {
      text: 'Join us on Twitter / X',
    },
    link: 'https://twitter.com/JForceUganda',
    newPage: true
  }
]

const dashboardOtherItems = [
  {
    disabled: false,
    img: 'img/dashboard/faqs.svg',
    title: {
      key: 'dashboard.other.faq'
    },
    newPage: false,
    internalResource: true,
    link: 'jforce_faqs'
  },
  {
    img: 'img/dashboard/agreement.svg',
    title: {
      key: 'dashboard.other.agreement'
    },
    newPage: false,
    internalResource: true,
    link: ''
  },
  {
    img: 'img/dashboard/commissionGrid.svg',
    title: {
      key: 'dashboard.other.commission_grid'
    },
    link: pdfCommissions,
    newPage: true
  },
  {
    img: 'img/dashboard/university.svg',
    title: {
      text: 'JForce Training'
    },
    link: pdfTraining1,
    newPage: true
  },
  {
    img: 'img/dashboard/university.svg',
    title: {
      text: 'Jumia Training'
    },
    link: pdfTraining2,
    newPage: true
  },
  {
    img: 'img/dashboard/university.svg',
    title: {
      text: 'Sales techniques'
    },
    link: pdfTraining3,
    newPage: true
  }
]

export {
  referralLink,
  dashboardGetUpdatedItems,
  dashboardContactTheTeamItems,
  dashboardOtherItems
}
